import { server_connection } from 'config';
import { updateCourseBuilderParams } from '../../../../components/paramHistory/store/actions';
import history from 'history.js';

export const UPDATE_COURSE_SCAFFOLD = '[COURSE APP] UPDATE COURSE SCAFFOLD';
export const HANDLE_DAY_SELECT = '[COURSE APP] HANDLE DAY SELECT';
export const HANDLE_MAJOR_SELECT = '[COURSE APP] HANDLE MAJOR SELECT';
export const UPDATE_STEP = '[COURSE APP] UPDATE_STEP';
export const BUILDER_LESSON_DROP = '[COURSE APP] BUILDER LESSON DROP';
export const TOGGLE_LESSON_DIALOG = '[COURSE APP] TOGGLE LESSON DIALOG';
export const LESSON_DIALOG_CHOICE = '[COURSE APP] LESSON DIALOG CHOICE';
export const SELECT_LESSON_HUB = '[COURSE APP] SELECT LESSON';
export const UPDATE_LESSON_FORM = '[COURSE APP] UPDATE LESSON FORM';
export const SUBMIT_NEW_LESSON_HEADER = '[COURSE APP] SUBMIT NEW LESSON';
export const ADD_NEW_LESSON_SETUP = '[COURSE APP] ADD NEW LESSON SETUP';
export const DELETE_LESSON = '[COURSE APP] DELETE LESSON';
export const SUBMIT_COURSE = '[COURSE APP] SUBMIT COURSE';
export const GET_COURSE_ID = '[COURSE APP] GET COURSE ID';
export const RESET_BUILDER = '[COURSE APP] RESET BUILDER';
export const GET_MAJORS = '[COURSE APP] GET MAJORS';
/// UNSCHEDULED 
export const PUSH_UNSCHEDULED_LESSON = '[COURSE APP] PUSH UNSCHEDULED LESSON';
export const MOVE_UNSCHEDULED_LESSON = '[COURSE APP] MOVE UNSCHEDULED LESSON';
export const DELETE_UNSCHEDULED_LESSON = '[COURSE APP] DELETE UNSCHEDULED LESSON';
export const CLEAR_WIZARD = '[COURSE APP] CLEAR WIZARD';
export const GET_COMPANY_LIST ='[COURSE APP] GET COMPANY LIST';

export const BUILDER_COMPANY_UPDATE_SEARCH = '[COURSE APP] BUILDER COMPANY UPDATE SEARCH';
export const BUILDER_TOGGLE_COMPANY = '[COURSE APP] BUILDER TOGGLE COMPANY';

export function resetBuilder() {
    return {
        type: RESET_BUILDER
    }
}

export function updateCourseScaffold(course_scaffold_data) {
    return {
        type: UPDATE_COURSE_SCAFFOLD,
        payload: course_scaffold_data
    }
}

export function handleDaySelect(day_id) {
    return {
        type: HANDLE_DAY_SELECT,
        payload: day_id
    }
}

export function handleMajorSelect(major_id) {
    return {
        type: HANDLE_MAJOR_SELECT,
        payload: major_id
    }
}

export function updateStep(current_step) {
    return {
        type: UPDATE_STEP,
        payload: current_step
    }
}

export function builderLessonDrop(lesson, week, day) {
    return {
        type: BUILDER_LESSON_DROP,
        payload: {
            week: week,
            day: day,
            lesson: lesson
        }
    }
}

export function toggleLessonDialog(setting, info, unscheduled) {
    return {
        type: TOGGLE_LESSON_DIALOG,
        payload: { setting, info, unscheduled }
    }
}

export function lessonDialogChoice(choice) {
    return {
        type: LESSON_DIALOG_CHOICE,
        payload: choice
    }
}

export function selectLessonHub(lesson) {
    return {
        type: SELECT_LESSON_HUB,
        payload: lesson
    }
}

export function updateLessonForm(data) {
    return {
        type: UPDATE_LESSON_FORM,
        payload: data
    }
}

export function submitNewLessonHeader(lesson, choice) {
    return {
        type: SUBMIT_NEW_LESSON_HEADER,
        payload: { lesson: lesson, choice: choice }
    }
}

export function addNewLessonSetup(day) {
    return {
        type: ADD_NEW_LESSON_SETUP,
        payload: day
    }
}

export function deleteLesson(lesson) {
    return {
        type: DELETE_LESSON,
        payload: lesson
    }
}

export function getCourseId(course_id) {
    return {
        type: GET_COURSE_ID,
        payload: course_id
    }
}

export function builderCompanyUpdateSearch(characters) {
    return {
        type: BUILDER_COMPANY_UPDATE_SEARCH,
        payload: characters
    }
}

export function builderToggleCompany(company, action_type) {
    return {
        type: BUILDER_TOGGLE_COMPANY,
        payload: { company, action_type }
    }
}

export function getMajors(auth_id) {
    return (dispatch) => {
        return fetch(server_connection + '/major/list/' + auth_id)
            .then((response) => response.json())
            .then((majors) => {
                return dispatch({
                    type: GET_MAJORS,
                    payload: majors,
                });
            });
    }
}

export function getCompanyList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((companyList) => {
                dispatch({
                    type: GET_COMPANY_LIST,
                    payload: companyList,
                });
            });
    }
}

export function submitCourse(courseHeader, mappedLessons, majors, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/course/builder',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    courseHeader: courseHeader,
                    mappedLessons: mappedLessons,
                    majors: majors,
                    auth_id: auth_id
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (mappedLessons.length === 0) {
                    history.push({ pathname: '/course/edit/' + responseData.course_id })
                }
                else {
                    dispatch(updateCourseBuilderParams({ completedLessons: responseData.lesson_list, course_id: responseData.course_id, CourseName: courseHeader.CourseName, LessonName: responseData.lesson_list[0].LessonName }))
                    history.push({ pathname: '/lesson/edit/' + responseData.lesson_list[0].lesson_id })
                }
            })
    }
}

///// UNSCHEDULED COURSE

export function pushUnscheduledLesson(lesson) {
    return {
        type: PUSH_UNSCHEDULED_LESSON,
        payload: { lesson }
    }
}

export function moveUnscheduledLesson(dragIndex, hoverIndex, event) {
    return {
        type: MOVE_UNSCHEDULED_LESSON,
        payload: { dragIndex, hoverIndex, event }
    }
}

export function deleteUnscheduledLesson(lesson) {
    return {
        type: DELETE_UNSCHEDULED_LESSON,
        payload: lesson
    }
}

export function clearWizard() {
    return {
        type: CLEAR_WIZARD,
        payload: true
    }
}


// WEBPACK FOOTER //
// src/main/content/course/store/actions/course.builder.actions.js